<template>
    <div v-if="active" class="vue-box">
        <div class="frame">
            <slot class="title" name="title"></slot>
            <slot name="content"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Box',
        props: [
            'active',
        ],
        components: {
        }
    }
</script>
<style scoped lang="scss">
    @import "./Box.scss"
</style>


// WEBPACK FOOTER //
// resources/assets/vue/components/coverage/box/Box.vue